var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { TextField, IconButton, InputAdornment, Box, useTheme, } from "@mui/material";
import { Controller, } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import { ErrorMessage } from "./ValidationMessage";
export const FInput = (_a) => {
    var { name, control, label, error, helperText, hiddenLabel, size = "medium", type = "text", placeholder } = _a, props = __rest(_a, ["name", "control", "label", "error", "helperText", "hiddenLabel", "size", "type", "placeholder"]);
    const { t } = useTranslation(["form", "validation"]);
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme();
    const getValidationMessage = (fieldError) => (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) || helperText;
    const isPasswordField = type === "password";
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    return (React.createElement(Controller, { name: name, control: control, rules: props.rules, render: ({ field, fieldState: { error: fieldError } }) => {
            var _a;
            return (React.createElement(Box, { width: "100%" },
                React.createElement(TextField, Object.assign({}, field, props, { value: (_a = field.value) !== null && _a !== void 0 ? _a : "", onChange: field.onChange, hiddenLabel: hiddenLabel, placeholder: placeholder, required: false, type: isPasswordField && showPassword ? "text" : type, label: !hiddenLabel ? (React.createElement(React.Fragment, null,
                        t(label),
                        props.required && (React.createElement("span", { style: { color: theme.palette.error.main } }, "\u00A0*")))) : undefined, error: !!fieldError || !!error, fullWidth: true, variant: "outlined", size: size, InputProps: Object.assign({ endAdornment: isPasswordField && (React.createElement(InputAdornment, { position: "end" },
                            React.createElement(IconButton, { onClick: togglePasswordVisibility, edge: "end" }, showPassword ? (React.createElement(Icon, { icon: "eva:eye-off-outline", width: "24", height: "24" })) : (React.createElement(Icon, { icon: "eva:eye-outline", width: "24", height: "24" }))))) }, (props.InputProps || {})) })),
                React.createElement(ErrorMessage, { error: getValidationMessage(fieldError || error) })));
        } }));
};
